<template>
  <v-layout row wrap>
    <pg-detail
      :title="title"
      :primary_key="primary_key"
      :primary_field="primary_field"
      :fab="false"
    >
      <template slot="detail-content" slot-scope="props">
        <v-layout row wrap>
          <v-flex xs12 sm6>
            <v-list two-line subheader>
              <v-list-tile>
                <v-list-tile-action>
                  <v-icon color="secondary">directions_run</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>Nama Trainer</v-list-tile-title>
                  <v-list-tile-sub-title
                    >{{ props.detail.trainer }}
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-divider inset></v-divider>
              <v-list-tile
                v-ripple
                :to="{
                  name: 'TrainerDivisi',
                  query: { id: props.detail.id_trainer_divisi }
                }"
              >
                <v-list-tile-action>
                  <v-icon color="secondary">star</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>Divisi Trainer</v-list-tile-title>
                  <v-list-tile-sub-title
                    >{{ props.detail.trainer_divisi }}
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-divider inset></v-divider>
              <v-list-tile>
                <v-list-tile-action>
                  <v-icon color="secondary">style</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>Total ON-SITE</v-list-tile-title>
                  <v-list-tile-sub-title
                    >{{ props.detail.total_onsite }}
                    <small>Training</small>
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-divider inset></v-divider>
              <v-list-tile>
                <v-list-tile-action>
                  <v-icon color="secondary">style</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>Total OFF-SITE</v-list-tile-title>
                  <v-list-tile-sub-title
                    >{{ props.detail.total_offsite }}
                    <small>Training</small>
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-divider inset></v-divider>
              <v-list-tile>
                <v-list-tile-action>
                  <v-icon color="secondary">assignment_turned_in</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>Total Training</v-list-tile-title>
                  <v-list-tile-sub-title
                    >{{ props.detail.total_training }}
                    <small>Training</small>
                  </v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
              <v-divider inset></v-divider>
            </v-list>
          </v-flex>
          <v-flex xs12 sm6>
            <v-expansion-panel class="elevation-1" focusable>
              <v-expansion-panel-content :value="true">
                <div slot="header">TRAINING TERKAIT</div>
                <v-subheader v-if="!props.detail.training.length" class="mb-3">
                  {{ title }} ini tidak memiliki keterkaitan data dengan
                  TRAINING.
                </v-subheader>
                <vue-perfect-scrollbar v-else style="max-height: 400px">
                  <v-list two-line>
                    <v-list-tile
                      v-for="(item, i) in props.detail.training"
                      :key="i"
                      style="border-bottom: 1px solid #eee"
                      v-ripple
                      :to="{
                        name: 'TrainingList',
                        query: { id: item.id_training }
                      }"
                    >
                      <v-list-tile-content>
                        <v-list-tile-title>{{ item.materi }}</v-list-tile-title>
                        <v-list-tile-sub-title>{{
                          item.waktu_mulai | moment("from", "now")
                        }}</v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                </vue-perfect-scrollbar>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-flex>
        </v-layout>
      </template>
    </pg-detail>
    <template v-if="!$route.query.id">
      <v-flex xs12>
        <v-card>
          <v-card-title class="py-2">
            <json-excel
              :data="selected"
              :export-fields="jsonFields"
              :name="`${$route.name}.xls`"
            >
              <v-btn color="indigo" :disabled="selected.length == 0" dark icon>
                <v-icon>file_download</v-icon>
              </v-btn>
            </json-excel>
            <v-btn
              :color="!filterOn ? 'grey' : 'orange'"
              :disabled="!sourceData.length && !filterOn"
              dark
              icon
              @click.stop="filterDialog = true"
            >
              <v-icon>filter_list</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Pencarian"
              clearable
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>

          <v-data-table
            v-if="!$vuetify.breakpoint.xs"
            v-model="selected"
            :headers="headers"
            :items="sourceData"
            :search="search"
            :pagination.sync="pagination"
            :loading="!trainer_loaded"
            select-all
            item-key="id_trainer"
            :rows-per-page-items="pages"
            rows-per-page-text="Data/hlm"
            class="elevation-1"
          >
            <template slot="headers" slot-scope="props">
              <tr>
                <th>
                  <v-checkbox
                    :input-value="props.all"
                    :indeterminate="props.indeterminate"
                    primary
                    hide-details
                    @click.native="toggleAll"
                  >
                  </v-checkbox>
                </th>
                <th
                  v-for="header in props.headers"
                  :key="header.text"
                  :class="[
                    'column sortable ',
                    pagination.descending ? 'desc' : 'asc',
                    header.value === pagination.sortBy ? 'active' : '',
                    header.align ? `text-xs-${header.align}` : 'text-xs-left'
                  ]"
                  @click="changeSort(header.value)"
                >
                  <v-icon small>arrow_upward</v-icon>
                  {{ header.text }}
                </th>
              </tr>
            </template>
            <v-progress-linear
              slot="progress"
              color="primary"
              :height="3"
              indeterminate
            >
            </v-progress-linear>
            <template slot="items" slot-scope="props">
              <tr
                :active="props.selected"
                class="nowrap"
                @click="toggleExpand(props)"
              >
                <td style="width: 80px">
                  <v-checkbox
                    :input-value="props.selected"
                    @click.stop="props.selected = !props.selected"
                    primary
                    hide-details
                  >
                  </v-checkbox>
                </td>
                <td>
                  <v-chip
                    small
                    label
                    @click.stop="
                      $router.push({
                        name: $route.name,
                        query: { id: props.item.id_trainer }
                      })
                    "
                  >
                    {{ props.item.trainer }}
                  </v-chip>
                </td>
                <td>{{ props.item.trainer_divisi }}</td>
                <td class="text-xs-center">{{ props.item.total_onsite }}</td>
                <td class="text-xs-center">{{ props.item.total_offsite }}</td>
                <td class="text-xs-center">{{ props.item.total_training }}</td>
              </tr>
            </template>
            <template
              slot="expand"
              slot-scope="props"
              v-if="$vuetify.breakpoint.xs"
            >
              <v-card
                flat
                :color="$vuetify.dark ? 'grey darken-1' : 'grey lighten-5'"
              >
                <table class="expanded">
                  <tr v-for="(header, i) in headers" :key="`rows-${i}`">
                    <td>{{ header.text }}</td>
                    <td>{{ props.item[header.value] | noEmpty }}</td>
                  </tr>
                </table>
              </v-card>
            </template>
            <template slot="no-data">
              <v-alert
                :value="true"
                :color="trainer_loaded ? 'warning' : 'info'"
                :icon="trainer_loaded ? 'warning' : 'info'"
                class="pa-1"
              >
                <span v-if="!trainer_loaded">Mengambil data...</span>
                <span v-else>Tidak ada data.</span>
              </v-alert>
            </template>
            <v-alert
              slot="no-results"
              :value="true"
              color="warning"
              icon="warning"
              class="pa-1"
            >
              Kata kunci "{{ search }}" tidak ditemukan.
            </v-alert>
          </v-data-table>

          <v-data-iterator
            v-else
            v-model="selected"
            :items="sourceData"
            :pagination.sync="pagination"
            :loading="!trainer_loaded"
            :search="search"
            select-all
            item-key="id_trainer"
            :rows-per-page-items="pages"
            rows-per-page-text="Data/hlm"
            row
            wrap
          >
            <v-flex slot="item" slot-scope="props" xs12>
              <v-card>
                <v-list-tile>
                  <v-list-tile-action>
                    <v-checkbox
                      :input-value="props.selected"
                      @click.stop="props.selected = !props.selected"
                      class="ma-0 pa-0"
                      hide-details
                      primary
                    >
                    </v-checkbox>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>{{
                      props.item.trainer
                    }}</v-list-tile-title>
                    <v-list-tile-sub-title>{{
                      props.item.trainer_divisi
                    }}</v-list-tile-sub-title>
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <v-btn
                      :to="{
                        name: $route.name,
                        query: { id: props.item.id_trainer }
                      }"
                      fab
                      flat
                      small
                      color="primary"
                    >
                      <v-icon>keyboard_arrow_right</v-icon>
                    </v-btn>
                  </v-list-tile-action>
                </v-list-tile>
                <v-divider></v-divider>
                <v-slide-y-transition>
                  <!-- <div v-show="props.selected"> -->
                  <v-list
                    dense
                    :class="props.selected ? 'secondary white--text' : ''"
                  >
                    <v-list-tile v-for="(header, i) in simpleHeaders" :key="i">
                      <v-list-tile-content>
                        <v-list-tile-title>{{ header.text }}</v-list-tile-title>
                        <v-list-tile-sub-title>{{
                          props.item[header.value] | noEmpty
                        }}</v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                  <!-- </div> -->
                </v-slide-y-transition>
              </v-card>
            </v-flex>
            <template slot="no-data">
              <v-alert
                :value="true"
                color="warning"
                icon="warning"
                class="pa-1"
              >
                <span v-if="status.loading">Loading...</span>
                <span v-else>Tidak ada data.</span>
              </v-alert>
            </template>
            <v-alert
              slot="no-results"
              :value="true"
              color="warning"
              icon="warning"
              class="pa-1"
            >
              Kata kunci "{{ search }}" tidak ditemukan.
            </v-alert>
          </v-data-iterator>
        </v-card>
      </v-flex>

      <pg-form-filter
        :dialog="filterDialog"
        :filterOn="filterOn"
        :filter="filter"
        :source="sourceData"
        :sourceOriginal="sourceOriginal"
        :title="title"
        @close="filterDialog = false"
        @toggle="
          filterOn = !filterOn;
          filterDialog = false;
        "
        @filtered="filterSource = $event"
      >
        <template slot="filter-content" slot-scope="props">
          <v-autocomplete
            append-icon="directions_run"
            attach
            hide-details
            item-text="trainer"
            item-value="id_trainer"
            multiple
            :items="trainer"
            v-model="props.filter.id_trainer"
            label="Trainer"
          >
            <template slot="selection" slot-scope="data">
              {{ `${data.item.trainer} (${data.item.trainer_divisi})` }},
            </template>
            <template slot="item" slot-scope="data">
              <v-list-tile-content>
                <v-list-tile-title>{{ data.item.trainer }}</v-list-tile-title>
                <v-list-tile-sub-title>{{
                  data.item.trainer_divisi
                }}</v-list-tile-sub-title>
              </v-list-tile-content>
            </template>
          </v-autocomplete>
          <v-autocomplete
            append-icon="star"
            attach
            hide-details
            item-text="trainer_divisi"
            item-value="id_trainer_divisi"
            multiple
            :items="trainer_divisi"
            v-model="props.filter.id_trainer_divisi"
            label="Divisi Trainer"
          >
          </v-autocomplete>
          <v-range-slider
            v-model="props.filter.total_onsite"
            label="Total ON-SITE"
            append-icon="style"
            hide-details
            style="margin-top: 40px"
            always-dirty
            :min="props.filter.field.total_onsite[0]"
            :max="props.filter.field.total_onsite[1]"
            thumb-label="always"
          >
          </v-range-slider>
          <v-range-slider
            v-model="props.filter.total_offsite"
            label="Total OFF-SITE"
            append-icon="style"
            hide-details
            style="margin-top: 40px"
            always-dirty
            :min="props.filter.field.total_offsite[0]"
            :max="props.filter.field.total_offsite[1]"
            thumb-label="always"
          >
          </v-range-slider>
          <v-range-slider
            v-model="props.filter.total_training"
            label="Total Training"
            append-icon="assignment_turned_in"
            hide-details
            style="margin-top: 40px"
            always-dirty
            :min="props.filter.field.total_training[0]"
            :max="props.filter.field.total_training[1]"
            thumb-label="always"
          >
          </v-range-slider>
        </template>
      </pg-form-filter>
    </template>
  </v-layout>
</template>


<script>
import _ from "lodash";
import c from "@/constants";
import JsonExcel from "vue-json-excel";
import PgDetail from "@/components/private/PgDetail";
import PgFormFilter from "@/components/private/PgFormFilter";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { mapState } from "vuex";

const defaultFilter = {
  id_trainer: [],
  id_trainer_divisi: [],
  total_onsite: [0, 100],
  total_offsite: [0, 100],
  total_training: [0, 100],
  field: {
    total_onsite: [0, 100],
    total_offsite: [0, 100],
    total_training: [0, 100]
  },
  format: {
    id_trainer: c.FORMAT.options,
    id_trainer_divisi: c.FORMAT.options,
    total_onsite: c.FORMAT.number,
    total_offsite: c.FORMAT.number,
    total_training: c.FORMAT.number
  }
};

export default {
  name: "laporan-trainer",
  components: {
    JsonExcel,
    VuePerfectScrollbar,
    PgDetail,
    PgFormFilter
  },
  data() {
    return {
      // datatable
      headers: [
        { text: "TRAINER", value: "trainer" },
        { text: "DIVISI", value: "trainer_divisi" },
        { text: "TRAINING ON-SITE", value: "total_onsite", align: "center" },
        { text: "TRAINING OFF-SITE", value: "total_offsite", align: "center" },
        { text: "TOTAL TRAINING", value: "total_training", align: "center" }
      ],
      pagination: {
        sortBy: "total_training",
        descending: true
      },
      pages: [7, 10, 25, { text: "Semua", value: -1 }],
      selected: [],
      search: "",
      //dialog
      title: "TRAINER",
      primary_field: "trainer",
      primary_key: "id_trainer",
      // filter
      filterDialog: false,
      filterSource: [],
      filterOn: false,
      filterHelperSourceUpdated: false,
      filter: _.cloneDeep(defaultFilter),
      // other
      c: c
    };
  },
  computed: {
    ...mapState(["status"]),
    ...mapState("trainer_divisi", ["trainer_divisi"]),
    ...mapState("trainer", ["trainer", "trainer_loaded"]),
    simpleHeaders() {
      return this.headers.filter(
        h => !["trainer", "trainer_divisi"].includes(h.value)
      );
    },
    jsonFields() {
      return this.headers.reduce(
        (obj, item) => ((obj[item.text] = item.value), obj),
        {}
      );
    },
    sourceOriginal() {
      /* eslint-disable */
      this.filterHelperSourceUpdated = true;
      return _.cloneDeep(this.$store.getters["trainer/trainerByPeriode"]);
    },
    sourceData() {
      let source = _.cloneDeep(this.sourceOriginal);
      if (
        (this.filterOn && !_.isEqual(source, this.filterSource)) ||
        (this.filterHelperSourceUpdated && this.filterSource.length)
      ) {
        source = this.filterSource;
        /* eslint-disable */
        this.filterHelperSourceUpdated = false;
      }
      return source;
    }
  },
  methods: {
    toggleAll() {
      if (this.selected.length == this.sourceData.length) this.selected = [];
      else this.selected = _.cloneDeep(this.sourceData);
    },
    toggleExpand(props) {
      if (this.$vuetify.breakpoint.smAndDown) {
        if (!props.selected) props.expanded = !props.expanded;
        else props.expanded = false;
      } else props.expanded = false;
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    }
  },
  mounted() {}
};
</script>
